import { useAppSelector } from '@/store/store-hooks'
import { selectMattersListForTable } from './selectors'

/**
 * Returns matters shaped for the table.
 *
 * The table shows an access level derived from each matter's `member_count`
 * (provided by the matter list API). We intentionally do NOT fetch per-member
 * avatars here: it would fire a separate members request per row. Member avatars
 * render on the matter-overview header instead (see CollaborationHeaderActions).
 */
export function useMattersForTable() {
  return useAppSelector(selectMattersListForTable)
}
